var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09375 4.4375C2.62776 4.4375 2.25 4.81526 2.25 5.28125V13.7188C2.25 14.1847 2.62776 14.5625 3.09375 14.5625H14.9062C15.3722 14.5625 15.75 14.1847 15.75 13.7188V5.28125C15.75 4.81526 15.3722 4.4375 14.9062 4.4375H3.09375ZM1.125 5.28125C1.125 4.19394 2.00644 3.3125 3.09375 3.3125H14.9062C15.9936 3.3125 16.875 4.19394 16.875 5.28125V13.7188C16.875 14.8061 15.9936 15.6875 14.9062 15.6875H3.09375C2.00644 15.6875 1.125 14.8061 1.125 13.7188V5.28125Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49349 5.77966C3.68422 5.53444 4.03762 5.49026 4.28284 5.68099L9 9.34989L13.7172 5.68099C13.9624 5.49026 14.3158 5.53444 14.5065 5.77966C14.6972 6.02488 14.6531 6.37828 14.4078 6.56901L9.34534 10.5065C9.14222 10.6645 8.85778 10.6645 8.65466 10.5065L3.59216 6.56901C3.34694 6.37828 3.30276 6.02488 3.49349 5.77966Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5bafe634b975356e1f922720bdce6fc3.svg";
export { ForwardRef as ReactComponent };